/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import Filters from "../../Components/Reports/Filters";
import moment from "moment";
import styles from "../../Styles/dashboard.module.css";
import { useLocation } from "react-router-dom";
import { Grid, useMediaQuery } from "@mui/material";
import useCustomMemo from "../../Components/GenericComponents/useCustomMemo";
import WorkflowReport from "../../Components/Reports/WorkflowReport";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import { dayPilotFormat } from "../../Utils/Config";
import { FiltersModel } from "../../Utils/Models";

export default function WorkflowsReports() {
  const location = useLocation();
  const phoneStyle = useMediaQuery("(max-width:800px)");
  const cache = useCustomMemo();
  const workflows = cache.workflows || [];
  const [indexedWorkflows, setIndexedWorkflows] = useState<any>({
    evenIndexedWorkflows: [],
    oddIndexedWorkflows: [],
  });
  const [filters, setFilters] = useState<FiltersModel>({
    startDate: moment().subtract(1, "months"),
    endDate: moment(),
    user: null,
    order: null,
    workflow: [],
  });

  /**
   *
   */
  useEffect(() => {
    let search: any = decodeURIComponent(location.search);
    search = search.split(/[?&]+/);
    const newFilters: any = {
      startDate: moment().subtract(1, "months"),
      endDate: moment(),
      user: null,
      order: null,
      workflow: [],
    };
    let workflow: any = [];
    search.forEach((value: any) => {
      if (value !== "") {
        const values = value.split("=");
        newFilters[values[0]] = isNaN(+values[1]) ? values[1] : +values[1];
        if (values[0] === "page") newFilters[values[0]] = +values[1] - 1;
        if (values[0] === "workflow") {
          newFilters[values[0]] =
            values[1] === "null" ? [] : values[1].split(",");
          workflow = values[1] === "null" ? null : [];
        }
        if (values[1] === "null") newFilters[values[0]] = null;
      }
    });
    if (
      newFilters.workflow.length === 0 &&
      filters.workflow.length === 0 &&
      workflow !== null
    ) {
      newFilters.workflow =
        workflows.length !== 0 && workflows[0]._id ? [workflows[0]._id] : [];
    }
    if (newFilters.workflow.length === 0) {
      setIndexedWorkflows({
        evenIndexedWorkflows: workflows.filter(
          (_: any, index: any) => index % 2 === 0
        ),
        oddIndexedWorkflows: workflows.filter(
          (_: any, index: any) => index % 2 !== 0
        ),
      });
    } else {
      setIndexedWorkflows({
        evenIndexedWorkflows: newFilters.workflow.filter(
          (_: any, index: any) => index % 2 === 0
        ),
        oddIndexedWorkflows: newFilters.workflow.filter(
          (_: any, index: any) => index % 2 !== 0
        ),
      });
    }
    setFilters({
      ...newFilters,
      startDate: moment(newFilters.startDate, dayPilotFormat),
      endDate: moment(newFilters.endDate, dayPilotFormat),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  /**
   *
   */
  async function recalculateReports() {
    const response = await getData(urlEnum.workflowsReports);
    if (
      response &&
      response.data &&
      (response.status === 200 || response.status === 201)
    ) {
      window.location.reload();
    }
  }
  return (
    <div
      className={
        phoneStyle
          ? styles.mainContainerReportsMobile
          : styles.mainContainerReports
      }
    >
      <Filters
        filters={filters}
        recalculateReportsButton={true}
        recalculateReportsFunction={recalculateReports}
        workflow={{
          show: true,
          multiple: true,
          disableClearable: true,
        }}
        showWorkflowLegend={true}
      />
      <Grid
        container
        spacing={4}
        style={phoneStyle ? { marginBottom: 80 } : {}}
      >
        {filters.workflow.length !== 0 ? (
          <>
            <Grid
              item
              xs={12}
              md={12}
              lg={filters.workflow.length === 1 ? 12 : 6}
            >
              {indexedWorkflows.evenIndexedWorkflows.map((workflow: any) => (
                <WorkflowReport
                  key={workflow}
                  workflowId={workflow}
                  filters={filters}
                />
              ))}
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={filters.workflow.length === 1 ? 12 : 6}
            >
              {indexedWorkflows.oddIndexedWorkflows.map((workflow: any) => (
                <WorkflowReport
                  key={workflow}
                  workflowId={workflow}
                  filters={filters}
                />
              ))}
            </Grid>
          </>
        ) : (
          <>
            <Grid
              item
              xs={12}
              md={12}
              lg={filters.workflow.length === 1 ? 12 : 6}
            >
              {indexedWorkflows.evenIndexedWorkflows.map((workflow: any) => (
                <WorkflowReport
                  key={workflow._id}
                  workflowId={workflow._id}
                  filters={filters}
                />
              ))}
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={filters.workflow.length === 1 ? 12 : 6}
            >
              {indexedWorkflows.oddIndexedWorkflows.map((workflow: any) => (
                <WorkflowReport
                  key={workflow._id}
                  workflowId={workflow._id}
                  filters={filters}
                />
              ))}
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
}
